import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import emailjs from "emailjs-com";
import { SecondaryButton } from "../Buttons";
import Banner from "../../assets/images/opentime.jpg";
import BannerOne from "../../assets/images/cover1.webp";

import ReCAPTCHA from "react-google-recaptcha"; // Added import

const schema = yup
  .object({
    fullName: yup
      .string()
      .min(3, "Your full name should be at least 3 characters.")
      .required("Please enter your first name."),
    subject: yup
      .string()
      .min(3, "Subject should be at least 3 characters.")
      .required("Please enter subject"),
    email: yup
      .string()
      .email("Please enter a valid email address.")
      .required("Please enter your email."),
    body: yup
      .string()
      .min(3, "Your message should be at least 3 characters.")
      .required("Please enter your message."),
  })
  .required();

export function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null); // Added state for reCAPTCHA token

  function onSubmit(data) {
    if (!recaptchaToken) {
      // Check for reCAPTCHA token
      window.alert("Please click to verify reCAPTCHA!");
      return;
    }

    const templateParams = {
      ...data,
      "g-recaptcha-response": recaptchaToken, // Include reCAPTCHA token
    };
    emailjs
      .send(
        "service_gpkyeng",
        "template_qgg4pin",
        templateParams,
        "XHRxxVuzePZubZk48"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSubmitSuccess(true);
          reset();
          setRecaptchaToken(null); // Reset reCAPTCHA token on success
        },
        (error) => {
          console.log("FAILED...", error);
          window.alert("ERROR! Could not send message. Please try again!");
          reset();
          setRecaptchaToken(null); // Reset reCAPTCHA token on failure
        }
      );
  }

  useEffect(() => {
    if (submitSuccess) {
      window.alert("Your message was sent successfully!");
      setSubmitSuccess(false);
    }
  }, [submitSuccess]);

  return (
    <div className="my-5 p-3 relative h-screen">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50"
        style={{ backgroundImage: `url(${BannerOne})` }}
      ></div>
      <div className="absolute left-1/2 transform -translate-x-1/2 w-full md:w-3/4  top-28 flex-col items-center mx-auto">
        <h1 className="text-center">kontakt oss</h1>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex-col md:w-2/4 content-center mx-auto"
        >
          <div className="mb-4">
            <label htmlFor="fullName" className="font-semibold">
              Navn
            </label>
            <input
              type="text"
              id="fullName"
              {...register("fullName")}
              className={`mt-1 p-2 text-black ${
                errors.fullName ? "error-border" : "border-gray-300"
              } rounded w-full`}
              placeholder="John Smith"
            />
            <p className="text-primary">{errors.fullName?.message}</p>
          </div>
          <div className="mb-4">
            <label
              htmlFor="subject"
              className="block text-gray-600 font-semibold"
            >
              Emne
            </label>
            <input
              type="text"
              id="subject"
              {...register("subject")}
              className={`mt-1 p-2 text-black ${
                errors.subject ? "error-border" : "border-gray-300"
              } rounded w-full`}
              placeholder="Ditt emne"
            />
            <p className="text-primary">{errors.subject?.message}</p>
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block font-semibold">
              E-post
            </label>
            <input
              type="email"
              id="email"
              {...register("email")}
              className={`mt-1 p-2 text-black ${
                errors.email ? "error-border" : "border-gray-300"
              } rounded w-full`}
              placeholder="abc@mail.com"
            />
            <p className="text-primary">{errors.email?.message}</p>
          </div>
          <div className="mb-4">
            <label htmlFor="body" className="block font-semibold">
              Melding
            </label>
            <textarea
              id="body"
              {...register("body")}
              className={`mt-1 p-2 text-black ${
                errors.body ? "error-border" : "border-gray-300"
              } rounded w-full`}
              placeholder="Meldingen din går her..."
            ></textarea>
            <p className="text-primary">{errors.body?.message}</p>
          </div>
          <div className="mb-4">
            <ReCAPTCHA
              sitekey="6LcOHv4pAAAAABVGYkwfmQX-5xBxRSHTiBy045H3" // Added reCAPTCHA component
              onChange={(token) => setRecaptchaToken(token)}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>
          <div className="mt-4 text-center">
            <SecondaryButton label="Sende" />
          </div>
        </form>
      </div>
    </div>
  );
}

export function ContactCover() {
  return (
    <div className="relative h-screen w-full flex justify-center items-center">
      {/* Original Background */}
      <div
        className="absolute w-full h-full bg-cover bg-no-repeat opacity-50"
        style={{
          backgroundImage: `url(${Banner})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
        }}
      ></div>

      {/* Content with Transparent Mirrored Background */}
      <div className="absolute inset-0 flex justify-end items-center p-12 border rounded-xl relative">
        {/* Mirrored Transparent Background */}
        <div
          className="absolute inset-0 bg-black opacity-80"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "top left",
            transform: "scaleX(-1)", // Creates the mirror effect
            mixBlendMode: "overlay", // Helps blend the mirrored image
          }}
        ></div>

        {/* Fully Centered Content */}
        <div className="relative z-10 text-center">
          <p className="mb-6 text-5xl text-light">Åpningstider:</p>
          <p className="text-white text-base md:text-xl">
            Ons-Søn: <span>14:00 - 21:00</span>
          </p>
          <p className="text-white text-base md:text-xl mt-2">
            Man & Tir: <span>Stengt</span>
          </p>
        </div>
      </div>
    </div>
  );
}


